module.exports = __webpack_public_path__ + "static/img/hzyxl.cf2c6ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hzyxl.png
// module id = Ch2M
// module chunks = 0